import Vue from 'vue'
import EventBus from '@/vue/events/event-bus'

export default {
  methods : {
    teamMouseOver(event) {
      if(event) {
        var elem = $('.sportTable').find('#'+event.eveid)
        if (elem.length > 0) {
          elem.css("display","block")
        }
      }
    },
    teamMouseLeave(event) {
      if(event) {
        var elem = $('.sportTable').find('#'+event.eveid)
        if (elem.length > 0) {
          elem.css("display","")
        }
      }
    },
    favouritedEvent(eveid, sportId, favEvent){
      var lgeFav = false
      if(favEvent!=undefined && favEvent[sportId]!=undefined){
        if(favEvent[sportId].includes(eveid)){
          lgeFav = true
        }
      }
      return lgeFav
    },
    favourite(event, isrb = false) {
      if(!(event && (event.length > 0 || Object.keys(event).length > 0))) {
        return
      } 
      if(this.$store.getters.int_marketToggle=='3' || this.$store.getters.int_marketToggle=='1' && event.rbstatus==1){
        isrb = true
      }
      this.$store.commit('SETFAVOURITE', { event : event, isrb: isrb })
      this.$store.dispatch('sortEvents')
      // if(this.$store.getters.showFavEvents){
      //   if(this.$store.getters.int_marketToggle==1){
      //     this.$store.dispatch('getTodayRBSportOdds', {
      //       callback: ((res) => {
      //         EventBus.$emit('refreshOdd', true)
      //       }).bind(this)
      //     })  
      //   }
      //   if(this.$store.getters.arr_selectedTemplate.subTemplateId == '3'){
      //     this.$store.dispatch('getOutrightLeague', {
      //       callback: ((res) => {
      //         EventBus.$emit('refreshOdd', true)
      //       }).bind(this)
      //     })
      //   }
      //   if(this.$store.getters.int_marketToggle==3){
      //     this.$store.dispatch('getLiveSportOdds', {
      //       callback: ((res) => {
      //         EventBus.$emit('refreshOdd', true)
      //       }).bind(this)
      //     })  
      //   }else{
      //     this.$store.dispatch('getSportOdds', {
      //       callback: ((res) => {
      //         EventBus.$emit('refreshOdd', true)
      //       }).bind(this)
      //     })
      //   }
      // }
    },
    favouriteAllBet(event, isrb = false) {
      if(this.$store.getters.int_marketToggle=='3'){
        isrb = true
      }
      this.$store.commit('FAVOURITEALLBETEVENT', { event : event, isrb: isrb })
      // if(this.$store.getters.showFavEvents){
      //   this.$store.dispatch('getSportAllBet', {
      //     callback: ((res) => {
      //       EventBus.$emit('refreshOdd', true)
      //     }).bind(this)
      //   })
      // }
    },
    favouriteTeam(event,team) {
      this.$store.commit('FAVOURITE_TEAM', { event: event, team: team, sport: this.$store.getters.selectedSport })
    },
    favouritelgeve(lgeid, wevent, isrb, eventObj) {
      wevent.preventDefault()
      wevent.stopPropagation()
      var lgChk = $(wevent.target).hasClass('favorited')
      this.$store.commit('FAVOURITELGEVENT', { lgeid : lgeid, lgeChk: lgChk, isrb: isrb, eventObj: eventObj })
      
      if(this.$store.getters.showFavEvents){
        if(this.$store.getters.arr_selectedTemplate.subTemplateId == '3'){
          this.$store.dispatch('getOutrightLeague', {
            callback: ((res) => {
              EventBus.$emit('refreshOdd', true)
            }).bind(this)
          })
        }else{
          this.$store.dispatch('getSportOdds', {
            callback: ((res) => {
              EventBus.$emit('refreshOdd', true)
            }).bind(this)
          })
        }
      }
    },
    lgFavorite(lgId,btPage,favouriteLgeEvents) {
      var lgeFav = false
      if(favouriteLgeEvents!=undefined && favouriteLgeEvents[btPage]!=undefined){
        if(favouriteLgeEvents[btPage].includes(lgId)){
          lgeFav = true
        }
      }
      return lgeFav
    },
    lgAllBetFavorite(lgMatches) {
      var lgeFav = true
      if(lgMatches.isFavourite==undefined || !lgMatches.isFavourite){
        lgeFav = false
      }
      return lgeFav
    },
    showForecast(event,windowEvent) {
      this.$store.commit('SPORTFORECAST_TOGGLE', true)
      this.$store.commit('SPORTFORECAST_SELECTEDEVENT', event)
      this.$store.commit('SPORTFORECAST_WINDOWEVENT', windowEvent)
      EventBus.$emit('SHOW_FORECAST',event)

      //if have betform show then calculate immediate
      if(this.$store.getters.betForm.length > 0 && !this.$store.getters.betting.success) {
        EventBus.$emit('FORECAST_GETWAITINGLIST', event)
      }else{
        EventBus.$emit('FORECAST_GETWAITINGLIST', null)
      }
    },

  }
}



// WEBPACK FOOTER //
// ./resources/score/vue/mixins/favourite.js